<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> 검사결과 리스트
      </template>
      <b-row>
        <b-col sm="6">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10"  />
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='agent.nickname';so.skt='에이전트 이름'">에이전트 이름</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.ip_addr';so.skt='에이전트 아이피'">에이전트 아이피</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.host';so.skt='호스트 이름'">호스트 이름</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="agent" slot-scope="row" v-if="row.item.agent">{{row.item.agent.nickname}}({{row.item.agent.host}}@{{row.item.agent.ip_addr}})</template>
        <template slot="scan_folder" slot-scope="row">{{row.item.scan_folder}} 점검갯수</template>
        <template slot="scan_count" slot-scope="row">{{row.item.scan_count}} 점검갯수</template>
        <template slot="detect_count" slot-scope="row" >{{row.item.detect_count ? row.item.detect_count+ '탐지갯수' : '-'}} </template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary" v-show="row.item.detect_count">조회</b-btn>
        </template>
      </b-table>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import { Api } from '@/service';

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  "sk" : "", "sv" : "", "skt" : "", "opt" : { },
})

export default {
  data: () => { return { so : default_opt() } },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields : function() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
        { key: 'agent', label: '에이전트', sortable: true, thStyle: 'width: 30%' },
        { key: 'scan_folder', label: '점검폴더', sortable: true },
        { key: 'scan_count', label: '점검파일', sortable: true },
        { key: 'detect_count', label: '탐지결과', sortable: true },
        { key: 'created_at', label: '점검일시', sortable: true },
        { key: 'func', label: '조회', sortable: false, thStyle: 'width: 10%'  },
      ]
    }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'wsfinder.result', cmd : 'list',
        body : { sort : [], or : [], and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [{ name : 'is_del', value : false, op : '='}, { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return Api.WSFinder(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { this.$router.push(`result/${item.id}`); },
  	hideList: function(e) {
      this.show = !e; console.log('Result.List.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created: function() { console.log('Result.List.vue', 'created'); },
  destroyed: function() { console.log('Result.List.vue', 'destroyed'); },
  mounted: function() { console.log('Result.List.vue', 'mounted'); },
}
</script>
